import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import isUnstable from '../utils/isUnstable';

var MenuDivider = function MenuDivider(_ref) {
  var className = _ref.className;
  isUnstable('MenuDivider');
  var ntClass = cx({
    'border-bottom': true,
    'marginbottom-md': true
  }, className);
  return /*#__PURE__*/React.createElement("div", {
    "aria-label": "divider",
    className: ntClass
  });
};

MenuDivider.propTypes = {
  className: PropTypes.string
};
MenuDivider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MenuDivider",
  "props": {
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
export default MenuDivider;